<template>
	<div class="menu-s-inscrire">
    <router-link :to="{ name: 'SignUpColocSelect' }" title="S'inscrire à COOLOC et créer un compte">
      <svgicon icon="signup" class="signup-icon"></svgicon>
      <span>S’inscrire</span>
    </router-link>
	</div>
</template>

<script>
export default {
  name: 'header-menu-signup',
}
</script>
